import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {


  checkResult({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/selfAndHmtEvaluation/checkResult', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getQualityTrain({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/findQuantityTrainingVideoAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  insertQuantityTrainingList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/insertQuantityTrainingList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  EventActivitiesAllList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/findEventActivitiesAllList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  insertEventActivitiesList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/insertEventActivitiesList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // electVideoIdList({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post('/schoolVideo/selectVideoIdList', params).then(res => {
  //       resolve(res)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  electVideoIdList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schoolVideo/selectVideoIdList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // electVideoIdList({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'post',
  //       url: '/schoolVideo/selectVideoIdList',
  //       params: params,
  //
  //     }).then(response => {
  //       resolve(response)
  //     }).catch((error) => {
  //       reject(error)
  //     })
  //   })
  // },

  //
  //   lookSchoolVideo({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post('/schoolVideo/lookSchoolVideo', params).then(res => {
  //       resolve(res)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  //   lookSchoolVideo({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post('/schoolVideo/lookSchoolVideo', params).then(res => {
  //       resolve(res)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  lookSchoolVideo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/schoolVideo/lookSchoolVideo',
        data: params,

      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  findApplication({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/application/findApplication', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findStudentUpload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/application/findStudentUpload', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  saveStudentApplication({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/application/saveStudentApplication', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  approvalStart({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/application/approvalStart', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findStatementGuidanceVideoAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/findStatementGuidanceVideoAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  insertStatementGuidanceVideoList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/insertStatementGuidanceVideoList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findFillInVideoAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/findFillInVideoAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  insertFillInVideoList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/eventActivities/insertFillInVideoList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findTree({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/trainingPlanCondition/findTree', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/trainingPlan/findList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendTrainingScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/trainingPlan/sendTrainingScheme', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findGuideSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/qualityScheme/findGuideSchemeList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteBySchemeNo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/qualityScheme/deleteBySchemeNo', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findTrainingPlanDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/trainingPlan/findTrainingPlanDetail', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendChannelScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/channelPlan/sendChannelScheme', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendSchemeBySchemeNo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/channelPlan/sendSchemeBySchemeNo', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  collegePlanList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/collegePlan/findList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findChannelPlanDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/channelPlan/findChannelPlanDetail', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendCollegeScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/collegePlan/sendCollegeScheme', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  coverLetterFindList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/coverLetter/findList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  batchRecommend({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/quality/coverLetter/batchRecommend', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/qualityScheme/saveMessage', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveContent({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/qualityScheme/saveContent', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findCollegePlanDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/collegePlan/findCollegePlanDetail', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  collagePlanList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/collegePlan/findList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  findSchemeScreenshotAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schemeScreenshot/findSchemeScreenshotAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  insertSchemeScreenshotAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schemeScreenshot/insertSchemeScreenshotAll', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  pushSchemeScreenshot({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schemeScreenshot/pushSchemeScreenshot', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  delSchemeScreenshot({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schemeScreenshot/delSchemeScreenshot', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  findOneSchemeScreenshot({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/schemeScreenshot/findOneSchemeScreenshot', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/qualityScheme/findMessage', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


}
